// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"cdbac570","235":"9e9d57cf","513":"dc5e10f9","668":"43ae051f","796":"9df6272c","876":"4ebc28f5"}[chunkId] + ".chunk.js";
};